import { render, staticRenderFns } from "./SkillsList.vue?vue&type=template&id=9f09fffc&scoped=true&"
import script from "./SkillsList.vue?vue&type=script&lang=js&"
export * from "./SkillsList.vue?vue&type=script&lang=js&"
import style0 from "./SkillsList.vue?vue&type=style&index=0&id=9f09fffc&prod&lang=scss&scoped=true&"
import style1 from "./SkillsList.vue?vue&type=style&index=1&id=9f09fffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f09fffc",
  null
  
)

export default component.exports